import psoResultsSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const psoResultsActions = { ...actions, ...thunkActions };
export * as PsoResultsTypes from './types';
export default psoResultsSlice;